import { PRPLAYGROUND_OR_LOCAL } from './localOrPlayground';
var STACK_TRACE_MAX = 1000;
export var captureError = function captureError(error) {
  // @ ts-ignore
  var hasNewRelic = typeof window !== 'undefined' && window.newrelic !== undefined;
  if (hasNewRelic && !PRPLAYGROUND_OR_LOCAL && error) {
    var _error$stack;
    // this could be updated at some point, not sure why NewRelic doesnt like too long of a stacktrace
    var newError = new Error(error.message);
    newError.name = "Upload Widget: ".concat(error.name);
    newError.stack = (_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.substr(0, STACK_TRACE_MAX);
    window.newrelic.noticeError(newError);
  }
  if (error) {
    console.error(error);
  }
};